"use strict";

const m = require("mithril");

const strings = require("./strings.csv");

const css = require("./footer.css");

module.exports = {
    view(vnode) {
        const esrbCSV = strings[vnode.attrs.lang].footer.esrb[vnode.attrs.footerLinks];

        return m("div",
            {
                class       : css.rating,
                "data-test" : "esrb-rating"
            },
            m("a", {
                    class        : css.esrb,
                    href         : "https://www.esrb.org",
                    target       : "_blank",
                    "aria-label" : "esrb"
                },
                "esrb"
            ),
            m("div",
                m("ul",
                    esrbCSV.upper.split(",").map((line) => m("li", line.trim()))
                ),
                esrbCSV.lower && [
                    m("hr"),
                    m("ul",
                        esrbCSV.lower.split(",").map((line) => m("li", line.trim()))
                    )
                ]
            )
        );
    }
};
